import handleError from "helpers/handleError";
import { useMutation } from "react-query";
import { conversation } from "services/chat-service";


export default function useConversation() {
    return useMutation({
        mutationFn: (payload: string) => conversation(payload),
        onSuccess: (res, variables) => {

        },
        onError: (err) => {
            handleError(err, "Error sending message.")
        }
    })
}   